import {
	Box,
	ThemeColorVariable,
	ThemeRadiusVariable,
	ThemeShadowVariable,
} from "@caspeco/casper-ui-library";
import NavBar from "./nav/nav-bar";
import { SIZE_LIMIT } from "../constants";
import { useLocation } from "react-router";
import { type JSX, useEffect } from "react";
import applicationInsights from "../services/application-insights/application-insights";
import { useUserContext } from "../hooks/use-user-context";
import { useAppContext } from "../hooks/use-app-context";

const Layout = ({ children }: { children: JSX.Element }) => {
	const isDesktopSize = window.innerWidth > SIZE_LIMIT;
	const location = useLocation();
	const { isSupport, isDeveloper } = useUserContext();
	const { safeArea } = useAppContext();

	useEffect(() => {
		if (location?.pathname) {
			applicationInsights.trackPageView(isSupport, isDeveloper, location.pathname);
		}
	}, [location, isSupport, isDeveloper]);

	return (
		<Box className="layout">
			<Box
				id="layout-children-box"
				height={"100vh"}
				w={"100%"}
				bg={ThemeColorVariable.Background}
				borderTopRadius={isDesktopSize ? ThemeRadiusVariable.Large : ThemeRadiusVariable.None}
				borderBottomRadius={isDesktopSize ? ThemeRadiusVariable.Large : ThemeRadiusVariable.None}
				paddingBottom={safeArea.bottomAsPx()}
			>
				{children}
			</Box>

			<Box
				className="navbar-container"
				boxShadow={ThemeShadowVariable.Footer}
				position={"fixed"}
				bottom={0}
				left={0}
				right={0}
			>
				<NavBar />
			</Box>
		</Box>
	);
};

export default Layout;
